// extracted by mini-css-extract-plugin
export default {"buttons":"HeaderResult_buttons__KMpsv","main-button":"HeaderResult_main-button__8cdtt"};